import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

type Variant = "primary" | "ghost" | "onblock";

const base =
  "inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-150 px-5 py-3 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:translate-y-px";
const variants: Record<Variant, string> = {
  primary: "bg-primary text-primary-foreground shadow-cta hover:bg-primary-hover",
  ghost: "border border-border bg-background text-foreground hover:border-primary hover:text-primary",
  onblock: "bg-white text-primary shadow-soft hover:bg-white/90",
};

export function Button({
  to,
  href,
  target,
  rel,
  variant = "primary",
  className,
  children,
  ...rest
}: {
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  variant?: Variant;
  className?: string;
  children: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const cls = cn(base, variants[variant], className);
  if (to) return <Link to={to} className={cls}>{children}</Link>;
  if (href) return <a href={href} target={target} rel={rel} className={cls}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
}
